import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import {
	getFriendsInfo,
	acceptFriendRequest,
} from '../../features/friendSlice.js'
import MembersDataGrid from '../../components/dataGrid/MembersDataGrid.jsx'
import { addFriendsByEmailBatch } from '../../features/friendSlice.js'
import { RemoveFriendPopup } from '../../components/popups/RemoveFriendPopup.jsx'
import InviteModal from '../../components/dataGrid/InviteModal.jsx'

export const FriendsPage = () => {
	const dispatch = useDispatch()
	const friends = useSelector((s) => s.friend.friends)

	const [inviteOpen, setInviteOpen] = useState(false)
	const openInvite = () => setInviteOpen(true)

	const [removingFriend, setRemovingFriend] = useState(false)
	const [selectedFriend, setSelectedFriend] = useState(null)

	const toggleSetRemovingFriend = (friend) => {
		if (!removingFriend) setSelectedFriend(friend)
		setRemovingFriend(!removingFriend)
	}

	useEffect(() => {
		dispatch(getFriendsInfo())
	}, [dispatch])

	const handleAccept = (memberId) => {
		dispatch(acceptFriendRequest(memberId))
	}
	
	const InviteModalSubmit = async (rows) => {
		await dispatch(addFriendsByEmailBatch(rows)).unwrap()
		await dispatch(getFriendsInfo()).unwrap()
		setInviteOpen(false)
	}

	return (
		<div>
			<RemoveFriendPopup
				removingFriend={removingFriend}
				friend={selectedFriend}
				clickHandler={toggleSetRemovingFriend}
			/>

			<MembersDataGrid
				members={friends}
				onAccept={handleAccept}
				onRemove={toggleSetRemovingFriend}
				onInviteClick={openInvite}
			/>

			<InviteModal
                type='friend'
				open={inviteOpen}
				onClose={() => setInviteOpen(false)}
				title="Add friends"
				subtitle="Add new friends to your friends list (up to 10 at a time)"
				withRole={false}
				submitLabel="Send Friend requests"
				onSubmit={InviteModalSubmit}
				roleLabel="Friend"
			/>
		</div>
	)
}
